import { Image, Text, MyPagesHero } from "@capioweb/ui-components"
import React from "react"
import { QBankImage } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { imageBlockDataToImageProps } from "../../utils"

interface MyPagesHeroBlockProps {
	heading: StringProperty
	imageDesktopBlock: QBankImage
	imageMobileBlock: QBankImage
}

const MyPagesHeroBlock: React.FC<MyPagesHeroBlockProps> = (props) => {
	const srcSetSizes = [
		{ width: 100, breakpoint: 768 },
		{ width: 1200, breakpoint: 992 },
		{ width: 2000, breakpoint: 1920 },
		{ width: 2560, breakpoint: 2560 },
	]
	return (
		<MyPagesHero
			media={
				<Image
					data-epi-edit="imageDesktopBlock"
					{...imageBlockDataToImageProps(
						props.imageDesktopBlock,
						true,
						true,
						srcSetSizes
					)}
				/>
			}
			content={
				<Text
					mb={1.75}
					as="h1"
					fontSize={{ _: 6, l: 8 }}
					lineHeight={{ _: 6, l: 8 }}
					fontWeight="bold"
					textColor="white"
				>
					{props.heading.value}
				</Text>
			}
		/>
	)
}

export { MyPagesHeroBlock }
